import { useContext } from 'react';

import { WorkflowContext } from '../contexts/WorkflowContext';

/**
 * Hook to access workflow node configurations and utilities.
 * Must be used within a WorkflowProvider.
 *
 * @throws Error if used outside WorkflowProvider
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const { nodeTypes, getNodeConfig } = useWorkflow();
 *
 *   const specializedNode = getNodeConfig('specialized');
 *
 *   return <ReactFlow nodeTypes={nodeTypes} />;
 * }
 * ```
 */
export function useWorkflow() {
  const context = useContext(WorkflowContext);

  if (!context) {
    throw new Error('useWorkflow must be used within a WorkflowProvider');
  }

  return context;
}
